import { Component, OnInit, AfterViewInit, HostListener } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, NgForm } from '@angular/forms';
import { LookupService, ApplicationService, DataService, BaseService } from '../../services';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { BankDetailsModel, AccountApplicationModel, PersonIncomeDetailModel, DocumentDetailsModel, crsDetailsModel, benDetailsModel, FatcaDetailsModel } from '../../models';
import { NationalityModel } from '../../models';
import { Route } from '@angular/compiler/src/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ViewChild, ElementRef } from '@angular/core';
import { MatStepper, MatDialog } from '@angular/material';
import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { AppConfig } from '../../_config'
import { DaoDialogComponent, DaoDropdownComponent } from 'src/app/directives';
import { DocumentAttachmentComponent } from '../document-attachment/document-attachment.component';
import { DeclarationsComponent } from '../declarations/declarations.component'
import { CommonHelper } from 'src/app/_modules/shared';
import { applicantDetailsModel } from 'src/app/models/account-opening-models/applicant-details.model';
import { FirebaseService } from 'src/app/services/firebase.service';


const masterFieldNames = ['CustomerTitle', 'CustomerName', 'CustomerFirstNameUDF', 'CustomerMiddleNameUDF', 'CustomerLastNameUDF',
  'LandlineNumber', 'ContactNumberOfficeUDF', 'ResidentStatus', 'ContactNumber', 'OtherReason1UDF', 'OtherReason2UDF', 'OtherReason3UDF', 'IAgreeCRSUDF'];
const personFieldNames = ['PersonFatherFirstNameUDF', 'PersonMotherFirstNameUDF', 'PersonNationalityLkp', 'N2UDF1', 'N2UDF2',
  'PlaceOfBirthLkp', 'PersonDateOfBirth', 'PersonCurrentAddressUDF', 'PersonAddressLkpUDF', 'GenderLkp', 'PersonResidenceLkp','PersonMailingAddressUDF'];
var accountOptions1, accountOptions2, accountOptions3

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})

export class HomeComponent implements OnInit, AfterViewInit {
  // Reference firstNameInput variable inside Component
  @ViewChild('basicDetailsForm') basicDetailsFormRef: ElementRef;
  @ViewChild("start") MyProp: ElementRef;

  @ViewChild(DocumentAttachmentComponent) documentAttachmentComponent: DocumentAttachmentComponent;
  @ViewChild(DeclarationsComponent) declarationsComponent: DeclarationsComponent;
  @ViewChild('stepper') formStepper:MatStepper;
  public model = {};
  public filteredBranchList = [];
  public filteredTrackerList = [];
  public cityList = [];
  public accountModel: any = {};
  public isStepEditable = true;
  public isStepperLinear = true;
  public showSubmit = false;
  public smallScreen: boolean = false;
  public xSmallScreen: boolean=false;
  logo = '';
  bankDetails: BankDetailsModel[] = [{ NameOfBankUDF: '', TypeOfAccount: '', AccountTitle: '', }];
  personIncomeDetail: PersonIncomeDetailModel[] = [{ MonthlyIncomeAmount: 0, IncomeSourceLkp: 0 }];
  documentModel: DocumentDetailsModel[] = [{ NationalIdTypeLkp: '', NationalIdentifierValue: '', NationalIdIssueDate: '', NationalIdExpiryDate: '', PlaceOfIssue: '' }];
  public applicantDetails: applicantDetailsModel[] = [];

  public Lookups: any = [];
  LookupForDeclaration: any;
  BranchesLookups: any = [];
  TrackerLookups: any = [];
  idLkpsArray: any = [];
  idLkpsArrayPlace: any = [];
  options: FormGroup;
  hideRequiredControl = new FormControl(false);
  floatLabelControl = new FormControl('auto');
  UploadFileControl = new FormControl();
  accountAppModel: any = {};
  startDate = new Date(1990, 0, 1);
  IssueDate = new Date(2018, 0, 1);
  ExpiryDate = new Date(2020, 0, 1);
  currentDate = new Date();
  zakatExemption = true;
  newCar = false;
  IsPakRupeeAccount = false;
  IsAccountSelected = false;
  IsAccount1Selected = false;
  IsAccount2Selected = false;
  IsAccount3Selected = false;
  IsAccount4Selected = false;
  IsAccount5Selected = false;
  IsPakRupeeAccountSav = false;
  IsUSDAccountSav = false;
  ApplicantCount = 1;
  OtpGenerated = false;
  OtpVerified = false;
  Salaried = false;
  SelfEmployed = false;
  Other = false;
  oldApp = false;
  Otp = 10;
  otp: any;
  countStart: any;
  accessCode:any;
  isDevEnv = false;
  CityId: any;
  zakat: any;
  idLength = 30;
  minPercent = 0;
  PrimaryNationalIdTypeLkpId = 296;
  showSpinner = false;
  addPurposeOne = false;
  addPurposeTwo = false;
  ResidenceNumber = false;
  OfficeNumber = false;
  addNationalityOne = false;
  addNationalityTwo = false;
  allFormsValid = true;
  onlyChild = true;
  onlySourceOfIncome = true;
  onlyNationality = true;
  // model variables
  isPassportSelected = false;
  saveInProgress = false;
  showMultipleApplicants = false;
  disableDebitCard = false;
  statementMonthlyLkp: Number;
  public isEstatementFrequencyMandatory = false;

  allowExit = false;

  constructor(private appConfig: AppConfig, private lookupService: LookupService, private baseService: BaseService,public firebase:FirebaseService,
    private applicationService: ApplicationService, public route: ActivatedRoute,private ngxService: NgxUiLoaderService,
    public toastr: ToastrService, public router: Router, private breakpointObserver: BreakpointObserver,
    private loaderService: NgxUiLoaderService, private dialog: MatDialog) {


    this.logo = appConfig.logoPath;
    this.isStepperLinear = !appConfig.testingMode; // if testing mode = true then we dont have to enforce linear stepper
    breakpointObserver.observe([
      Breakpoints.XSmall,
      Breakpoints.Small
    ]).subscribe(result => {
      this.smallScreen = result.matches;
    });
    this.getIPAddressAndLocation();
    this.getDataFromServer();
    this.bindModelDropDown();
    this.applicantDetails.push(this.getNewApplicantDetailObject());

    // console.log(JSON.stringify(DataService.get('Account')));

    // Defaults to 0 if no query param provided.

    if (DataService.get('Account')) {
      this.setModelFromData(DataService.get('Account'));
      this.postDataLoadFunction()
    }
    else {
      this.createEmptyModel();

    }
  }
  postLookupBindings(): void {
    let trueValueLkp = this.Lookups.AccountTypes.filter(x => x.LookupName == 'PKR');
    if (trueValueLkp.find(p => p.LookupId == this.accountAppModel.AccountTypeLkp1) || trueValueLkp.find(p => p.LookupId == this.accountAppModel.AccountTypeLkp2) || trueValueLkp.find(p => p.LookupId == this.accountAppModel.AccountTypeLkp3) || trueValueLkp.find(p => p.LookupId == this.accountAppModel.AccountTypeLkp4) || trueValueLkp.find(p => p.LookupId == this.accountAppModel.AccountTypeLkp5)) {
      this.IsPakRupeeAccount = true;
    }

    this.isEstatementFrequencyMandatory = true;
    this.accountAppModel.EStatementFrequency = this.statementMonthlyLkp;
    this.accountAppModel['EStatement'] = this.Lookups.Y_N.filter((element) => { return element.HiddenValue == 'Y' })[0].LookupId;
    this.accountAppModel['EStatementFrequency'] = this.Lookups.EStatementFrequencyLkp.filter((element) => { return element.HiddenValue == 'MONTHLY' })[0].LookupId;
    this.accountAppModel['JointId']=this.Lookups.CustomerRelationshipLkp.filter((element) => { return element.HiddenValue == 'Individual' })[0].LookupId;


  }
  showError(message: string) {
    //this.toastr.error(message);
    this.dialog.open(DaoDialogComponent, {
      data: {
        title: 'Error',
        message: message,
        type: 'error'
      }
    });
  }
  postDataLoadFunction() {
    if (this.accountAppModel['PurposeOfAccountOneUDF']) {
      this.addPurposeOne = true;
    }

    if (this.accountAppModel['PurposeOfAccountTwoUDF']) {
      this.addPurposeTwo = true;
    }

    if (this.accountAppModel['AccountTypeLkp1'] || this.accountAppModel['AccountTypeLkp2'] || this.accountAppModel['AccountTypeLkp3'] || this.accountAppModel['AccountTypeLkp4']) {
      this.IsAccountSelected = true;
    } else {
      this.IsAccountSelected = false;
    }
    this.ApplicantCount = this.applicantDetails.length;
    if(this.accountAppModel['CustomerRelationshipUDF']){
      this.onCustomerRelationshipChange(this.accountAppModel['CustomerRelationshipUDF']);
    }
    if(this.accountAppModel['AccountOperationUDF']){
      this.onAccountOperationChange(this.accountAppModel['AccountOperationUDF']);
    }
  }

  ngAfterViewInit() {

    // this.MyProp.nativeElement.scrollIntoView({ behavior: "smooth", block: "start" });

  }
  ngOnInit() {

    this.firebase.logEvent('Navigation | Basic Account Details');
    this.accountAppModel.EmailAddress = DataService.get('emailAddress');
    if(this.accountAppModel.EmailUDF)
        {this.firebase.setUserProp({Email: DataService.get('emailAddress')});}
    this.breakpointObserver
    .observe([Breakpoints.Small, Breakpoints.HandsetPortrait])
    .subscribe((state: BreakpointState) => {
      if (state.matches) {
        this.smallScreen = true;
      }
      else
      {
        this.smallScreen = false;
      }
    });

    this.breakpointObserver
    .observe(['(min-width: 768px)'])
    .subscribe((state: BreakpointState) => {
      if (state.matches) {
        this.xSmallScreen = true;
      }
      else
      {
        this.xSmallScreen = false;
      }
    });

    DataService.set('isLanding', false);

  }
  async GenerateOtp() {


    const searchRequest = {};
    searchRequest['Email'] = this.accountAppModel.EmailAddress;
    this.ngxService.start();
    await this.applicationService.GetOTP(searchRequest).toPromise().
      then(async res => {
        this.ngxService.stop();

        if (res  && res.status && res.status.code == '201') {
          this.firebase.logEvent('Action | OTP Generated');
          console.log(res.status.message);
          //this.router.navigate(['/home']);
          this.OtpGenerated = true;
          this.countStart = this.appConfig.AccessCodeExpiry;
          this.Otp = this.countStart;
          if (this.appConfig.env.toLowerCase() == 'dev') {
            this.accessCode = res.data;
            this.isDevEnv = true;
          }

        }

      }).catch(err => {
        this.ngxService.stop();
        console.log(err);
      });

    console.log('i m out');

  }

  async VerifyOtp() {

    this.ngxService.start();
    DataService.delete('emailAddress');
    DataService.delete('Account');


    const searchRequest = {};
    searchRequest['Email'] = this.accountAppModel.EmailAddress;
    searchRequest['OTP'] = this.otp;

    await this.applicationService.VerifyOTP(searchRequest).toPromise().
      then(async res => {
        if (res && res.data != null && res.status && res.status.code == '200') {
          console.log(res.status.message);
          this.OtpVerified = true;

        }
        else {
          this.ngxService.stop();
          this.showError("Invalid OTP, Please try again.");
          this.Otp = 0;
          return true;
        }

      }).catch(err =>
        console.log(err));
  }

  async postDetails(event: string, doInBackground = false) {
    event = event.toLowerCase();
    if (event == 'submit') {
      let validationResult = this.performValidationsForSubmit();
      if (!validationResult) {
        return;
      }
    } else {
      if (this.saveInProgress && doInBackground) {
        return;
      } else {
        this.saveInProgress = true;
      }
    }
    this.bindAccountAppModel();
    if (!doInBackground) {
      this.loaderService.start();
    }
    if (this.accountModel['AccountApplicationId']) {
      if(DataService.get('data'))
      this.setIds(DataService.get('data'));
      await this.applicationService.updateApplication(this.accountModel).toPromise()
        .then(async res => {
          this.saveInProgress = false;

          if (res && res.status && res.status.code == '200') {
            if (event == 'save') {
              this.loaderService.stop();
              if (doInBackground) {
                this.setIds(res.data);
                return;
              }
              this.firebase.logEvent('Action | Application Saved and Exited');
              let dialogRef = this.dialog.open(DaoDialogComponent, {
                data: {
                  title: 'Application Saved',
                  message: `Application has been saved with application number <b>${res.data.AccountApplicationNumber}.</b>
                  Please save this number to reference your application in future.`,
                  type: 'success'
                }
              });
              //this.toastr.success('Application Updated Successfully with Application Number' + ' ' + res.data.AccountApplicationNumber);
              dialogRef.afterClosed().subscribe(result => {
                this.allowExit = true;
                window.location.href = this.appConfig.LandingPageUrl;
                //this.router.navigate(['../accountOpening']);
              });



              return;
            }
            else if (event == 'submit') {
              //this.loaderService.start();
              await this.applicationService.initiateWF(this.accountModel).toPromise()
                .then(async response => {
                  this.saveInProgress = false;

                  this.loaderService.stop();
                  let dialogRef = this.dialog.open(DaoDialogComponent, {
                    data: {
                      title: 'Application Submitted',
                      message: `Application number <b>${res.data.AccountApplicationNumber}.</b> has been submitted successfully for further processing.`,
                      type: 'success'
                    }
                  });
                  this.firebase.logEvent('Action | Application Submitted Successfully');
                  //this.toastr.success('Application Updated Successfully with Application Number' + ' ' + res.data.AccountApplicationNumber);
                  dialogRef.afterClosed().subscribe(result => {
                    this.allowExit = true;
                    window.location.href = this.appConfig.LandingPageUrl;
                    //this.router.navigate(['../accountOpening']);
                  });
                  //return;
                }).catch(err => {
                  this.saveInProgress = false;


                  this.loaderService.stop();
                  this.toastr.error(err.error.Message);
                  this.router.navigate(['/accountOpening']);
                  return;
                }
                );
            }
          }
          else {
            this.toastr.error('An error occurred while processing your application, please contact support team for further details.');
            return;
          }
        }).catch(err => {
          this.saveInProgress = false;
          this.loaderService.stop();
          this.toastr.error('An error occurred while processing your application, please contact support team for further details.');
          console.log(err);
          // this.router.navigate(['/accountOpening']);
          return;
        });
    }
    else {
      await this.applicationService.postApplication(this.accountModel).toPromise()
        .then(async res => {
          this.saveInProgress = false;
          //this.loaderService.stop();
          if (res && res.status && res.status.code == '201') {
            if (event == 'save') {
              if (doInBackground) {
                this.setIds(res.data);
                return;
              }
              this.loaderService.stop();
              let dialogRef = this.dialog.open(DaoDialogComponent, {
                data: {
                  title: 'Application Saved',
                  message: `Application has been saved with application number <b>${res.data.AccountApplicationNumber}.</b>
                  Please save this number to reference your application in future.`,
                  type: 'success'
                }
              });
              this.firebase.logEvent('Action | Application saved and exited');
              dialogRef.afterClosed().subscribe(result => {
                this.allowExit = true;
                window.location.href = this.appConfig.LandingPageUrl;
                //this.router.navigate(['../accountOpening']);
              });
              //this.toastr.success('Application Created Successfully with Application Number' + ' ' + res.data.AccountApplicationNumber);
              this.setModelFromData(res.data);
              return;
            }
            else {
              await this.applicationService.initiateWF(res.data).toPromise()
                .then(async response => {
                  this.loaderService.stop();
                  this.firebase.logEvent('Action | Application Submitted Successfully');
                  let dialogRef = this.dialog.open(DaoDialogComponent, {
                    data: {
                      title: 'Application Submitted',
                      message: `Application number <b>${res.data.AccountApplicationNumber}.</b> has been submitted successfully for further processing.`,
                      type: 'success'
                    }
                  });

                  //this.toastr.success('Application Updated Successfully with Application Number' + ' ' + res.data.AccountApplicationNumber);
                  dialogRef.afterClosed().subscribe(result => {
                    this.allowExit = true;
                    window.location.href = this.appConfig.LandingPageUrl;
                    //this.router.navigate(['../accountOpening']);
                  });
                }).catch(err => {
                  this.toastr.error(err);
                  //this.router.navigate(['/accountOpening']);
                  return;
                }
                );
            }
          }
          else {
            this.toastr.error('An error occurred while processing your application, please contact support team for further details.');

            //this.toastr.error('Application can not be created');
            return;
          }
        }).catch(err => {
          this.saveInProgress = false;
          this.loaderService.stop();
          this.toastr.error('An error occurred while processing your application, please contact support team for further details.');
          console.log(err);
          //this.router.navigate(['/accountOpening']);
          return;
        });
    }
  }
  getNewApplicantDetailObject(): applicantDetailsModel {

    let app = {
      CustomerTitle: '', CustomerName: '', CustomerFirstNameUDF: '', CustomerMiddleNameUDF: '', CustomerLastNameUDF: '',
      PersonFatherFirstNameUDF: '', PersonMotherFirstNameUDF: '', nationalityLkp: null, PlaceOfBirthLkp: null, PersonDateOfBirth: '', ContactNumber: '',
      LandlineNumber: '', ContactNumberOfficeUDF: '', PersonAddressLkpUDF: null, PersonCurrentAddressUDF: '', ResidentStatus: '', PersonResidenceLkp: null,
      fatca: [{
        BirthCountry: '', CountryNames: '', CreatedBy: '',
        Nationalities: '', OutsidePakCheck: '', TIN: '', USCitizenReason: '', USLost: ''
      }],
      TmxPersonIncomeDetail: [{ IncomeSourceLkp: null, MonthlyIncomeAmount: '' }],
      TmxPersonNationalIdentifier: [{ NationalIdExpiryDate: '', NationalIdIssueDate: '', NationalIdentifierValue: '', PlaceOfIssue: '', }],
      crsDetails: [{ CountryOfTaxResidenceUDF: '', TINReasonUDF: '', TINUDF: '', OutsidePakCheck: '' }],
      TmxPersonProfessionDetail: [{ OfficeAddress: '', ProfessionTypeLkp: null, NameOfEmployer: '' }],
      nationality: [{ nationalityLkp: null }]
    } as applicantDetailsModel;
    app.panelExpanded = true;

    return app;
  }
  addBankDetail(event) {
    event.stopPropagation();
    if (!this.accountAppModel['TmxCustomerRelationship']) {
      this.accountAppModel['TmxCustomerRelationship'] = [];
    }
    this.accountAppModel['TmxCustomerRelationship'].push(new BankDetailsModel());
  }

  removeBankDetail(index) {
    if (this.accountAppModel['TmxCustomerRelationship'] && this.accountAppModel['TmxCustomerRelationship'].length > 0)
      this.accountAppModel['TmxCustomerRelationship'].splice(index, 1);
  }
  addSourceOfIncome(event: Event, TmxPersonIncomeDetail) {
    if (!TmxPersonIncomeDetail) {
      TmxPersonIncomeDetail = [];
    }
    TmxPersonIncomeDetail.push(new PersonIncomeDetailModel());
    this.onlySourceOfIncome = false;
    event.preventDefault();
  }
  addDocument(event: Event, index: number) {
    if (!this.applicantDetails[index]['TmxPersonNationalIdentifier']) {
      this.applicantDetails[index]['TmxPersonNationalIdentifier'] = [];
    }
    this.applicantDetails[index]['TmxPersonNationalIdentifier'].
      push(new DocumentDetailsModel());
    this.onlyChild = false;
    event.preventDefault();

  }
  removeIdDetail(event: Event, index: number, i: number) {
    if (this.applicantDetails[index]['TmxPersonNationalIdentifier'] && this.applicantDetails[index]['TmxPersonNationalIdentifier'].length > 1) {
      this.applicantDetails[index]['TmxPersonNationalIdentifier'].splice(i, 1);
      if (this.applicantDetails[index]['TmxPersonNationalIdentifier'].length < 2) {
        this.onlyChild = true;
      }
    }

    else {
      this.toastr.error("Atleast one Id document details is a must.");
    }
    event.preventDefault();

  }
  addApplicant(event: Event,j: Number,stepper: MatStepper) {
    this.ApplicantCount++;
    this.applicantDetails.forEach(x => x.panelExpanded = false);
    this.applicantDetails.push(this.getNewApplicantDetailObject());
    this.declarationsComponent.appDetails = this.applicantDetails;

    if(this.smallScreen)
    { const stepId = stepper._getStepLabelId(stepper.selectedIndex);
      const stepElement = document.getElementById(stepId);
      if (stepElement) {
        stepElement.scrollIntoView({ block: 'start', inline: 'nearest', behavior: 'smooth' });
      }
    }

    event.preventDefault();

  }
  removeApplicantDetail(event: Event, index, stepper: MatStepper) {
    this.ApplicantCount--;
    if (this.applicantDetails && this.applicantDetails.length > 1) {
      this.applicantDetails.splice(index, 1);

    }

    else {
      this.toastr.error("Atleast one applicant is mandatory.");
    }
    this.applicantDetails[index - 1].panelExpanded = true;
    this.declarationsComponent.appDetails = this.applicantDetails;
    if(this.smallScreen)
    { const stepId = stepper._getStepLabelId(stepper.selectedIndex);
      const stepElement = document.getElementById(stepId);
      if (stepElement) {
        stepElement.scrollIntoView({ block: 'start', inline: 'nearest', behavior: 'smooth' });
      }
    }
    event.preventDefault();

  }

  removeAllGuarantors()
  {

    //let temp = this.applicantDetails[0];

    for(let i=1; i < this.ApplicantCount; i++)
    {
      this.applicantDetails.pop();
    }

    //console.log(this.applicantDetails);
    this.accountModel['TmxLoanApplicationToGuarantorMapping']=null;
    this.accountAppModel['TmxLoanApplicationToGuarantorMapping']=null;
    this.ApplicantCount=1;
    if(this.declarationsComponent)
    {
      this.declarationsComponent.appDetails = this.applicantDetails;
    }
    this.applicantDetails[0].panelExpanded = true;

  }

  docTypeSelected(selectedIdLkp, idItem) {

    if (selectedIdLkp) {
      let selectedLookup = this.Lookups.IdentifierLkp.find(x => x.LookupId == selectedIdLkp);
      if (selectedLookup && selectedLookup.HiddenValue) {
        if(['cnic','nicop', 'poc', 'scnic'].includes(selectedLookup.HiddenValue.toLowerCase())){
          idItem.type="number";
        } else {
          idItem.type = null;
        }
        if (['cnic', 'arc', 'formb', 'nadra.token', 'nara', 'nicop', 'poc', 'scnic'].includes(selectedLookup.HiddenValue.toLowerCase())) {
          idItem.minLength = 13;
          idItem.maxLength = 13;
          return;
        }
        else if (['passport'].includes(selectedLookup.HiddenValue.toLowerCase())) {
          idItem.minLength = 7;
          idItem.maxLength = 10;
          return;
        }
        else if (['ntn'].includes(selectedLookup.HiddenValue.toLowerCase())) {
          idItem.minLength = 9;
          idItem.maxLength = 9;
          return;
        }
      }
    }
    else {
      idItem.NationalIdentifierValue = null;
    }

    idItem.minLength = 0;
    idItem.maxLength = 30;
    // this.idLength = 30;
  }
  getDataFromServer() {

    //this.bindModelDropDown();

    this.lookupService.getBranchesLookups().subscribe(lookupResponse => {
      DataService.set('Branches', lookupResponse);
      this.lookupService.saveBranchesLookups(lookupResponse.data);
      this.filterCitiesAndBranches();
    });
  }
  getIPAddressAndLocation() {
    this.baseService.GetIPData().subscribe(data => {
      console.log('Geting IP and Locatiion '+data);
      if (data) {
        this.accountAppModel["IPAddress"] = data.ip;
        this.accountAppModel["IPLocation"] = `${data.city} ${data.country_name}`;
      }
      else {
        this.accountAppModel["IPAddress"] = "N/A";
        this.accountAppModel["IPLocation"] = "N/A";
      }
    });
    }

  addNationality(event: Event, index) {

    this.applicantDetails[index].nationality.push(new NationalityModel());
    event.preventDefault();
  }


  removeSourceOfIncome(event: Event, index, TmxPersonIncomeDetail) {
    if (TmxPersonIncomeDetail && TmxPersonIncomeDetail.length > 0)
      TmxPersonIncomeDetail.splice(index, 1);
    if (TmxPersonIncomeDetail.length < 2) {
      this.onlySourceOfIncome = true;
    }
    event.preventDefault();
  }
  removeNationality(event: Event, index, applicantIndex) {
    if (this.applicantDetails[applicantIndex].nationality) {
      if (this.applicantDetails[applicantIndex].nationality.length > 0) {
        this.applicantDetails[applicantIndex].nationality.splice(index, 1);
      }
    }
    event.preventDefault();
  }

  createEmptyModel() {
    this.accountAppModel['TmxCustomerMaster'] = [];
    this.accountAppModel['TmxCustomerMaster'][0] = {};
    this.accountAppModel['EmailUDF'] = DataService.get('emailAddress');
    this.accountAppModel['UseMobileNumberAsUsername'] = '0';

  }
  filterCitiesAndBranches() {
    let uniqueCities = new Set(this.lookupService.Brancheslookups.map(x => x.CityName));
    this.cityList = Array.from(uniqueCities).map(city => ({ VisibleValue: city, LookupId: city }));
  }
  onCitySelected(city) {
    this.filteredBranchList= this.lookupService.Brancheslookups.filter(x => x.CityName == city).map(branch => ({ VisibleValue: branch.BranchName, LookupId: branch.CompanyBranchId }));
    console.log(city);
  }

  onProductSelected(product) {
    if(product == 94859){ //if non lien
      this.minPercent = 15;
      this.accountAppModel.DownPaymentPercentage = 15;
      this.filteredTrackerList = this.Lookups.TrackerAvailability.filter(x => x.VisibleValue == 'With Tracker').map(tracker => ({ VisibleValue: tracker.VisibleValue, LookupId: tracker.LookupId }));
    console.log(product);
    }else{
      this.minPercent = 0;
      this.accountAppModel.DownPaymentPercentage = 1;
      this.filteredTrackerList = this.Lookups.TrackerAvailability;
    }
    this.onFinchange(this.accountAppModel.CarPrice);

  }
  onMakeModelSelected(make) {


    if(this.Lookups.CarType.filter(x => x.LookupId == this.accountAppModel.CarType).map(y=>y.HiddenValue) == 'New'){
      this.accountAppModel.CarPrice = this.Lookups.MakeModel.filter(x => x.LookupId == make).map(y=>y.HiddenValue)[0];
    }
    this.onFinchange(this.accountAppModel.CarPrice);
    console.log(make);


  }
  onCarTypeSelected(type) {

    if(this.Lookups.CarType.filter(x => x.LookupId == type).map(y=>y.HiddenValue) == 'New'){
      this.newCar = true;
      if(this.accountAppModel.MakeModel){
        this.accountAppModel.CarPrice = this.Lookups.MakeModel.filter(x => x.LookupId == this.accountAppModel.MakeModel).map(y=>y.HiddenValue)[0];
        this.onFinchange(this.accountAppModel.CarPrice);

      }

    }else{
      this.newCar = false;
      this.accountAppModel.CarPrice = null;
    }
  }
  onEmploymentSelected(emp) {
    if(emp == '94885'){//if salaried
      this.Salaried = true;
      this.SelfEmployed = false;
      this.Other = false;
    console.log(emp);
    }else if (emp == '94886'){ //if self employeed
      this.SelfEmployed = true;
      this.Salaried = false;
      this.Other = false;
    }
    else if (emp =='94887'){//others
      this.Salaried = false;
      this.SelfEmployed = false;
      this.Other = true;
    }
    else{
      this.Salaried = false;
      this.SelfEmployed = false;
      this.Other = false;
    }

  }

  bindModelDropDown() {
    // this.showSpinner = true;
    this.lookupService.getAllLookups().subscribe(lookupResponse => {
      DataService.set('Lookups', lookupResponse);
      this.lookupService.saveLookups(lookupResponse);
      this.Lookups.IdentifierLkp = this.lookupService.getLookupByType('ID Type');
      this.idLkpsArray = this.Lookups.IdentifierLkp.filter(x => ['CNIC', 'FORMB'].includes(x.HiddenValue)).map(y => y.LookupId);
      this.idLkpsArrayPlace = this.Lookups.IdentifierLkp.filter(x => ['PASSPORT'].includes(x.HiddenValue)).map(y => y.LookupId);
      this.Lookups.TitleLkp = CommonHelper.OrderArrayByProperty(this.lookupService.getLookupByType('TITLES'), ['SortOrder'], ['asc']);
      this.Lookups.YesNo = this.lookupService.getLookupByType('YES_NO_BIT');
      this.Lookups.CustomerRelationshipLkp = this.lookupService.getLookupByType('CUSTOMER_RELATIONSHIP').filter(x => x.IsActive == 1);
      this.Lookups.AccountOperationLkp = this.lookupService.getLookupByType('ACCOUNT_KIND').filter(x => x.IsActive == 1);
      this.Lookups.Y_N = this.lookupService.getLookupByType('Y_N');
      this.Lookups.City = this.lookupService.getLookupByType('Expected Geographies City');
      this.Lookups.Branch = this.lookupService.getLookupByType('Expected Geographies City');
      this.Lookups.UserType = this.lookupService.getLookupByType('ID Type');
      this.Lookups.Devices = this.lookupService.getLookupByType('ID Type');
      this.Lookups.UsersRolesLov = this.lookupService.getLookupByType('ID Type');
      this.Lookups.ReportingUser = this.lookupService.getLookupByType('ID Type');
      this.Lookups.DesignationsLookup = this.lookupService.getLookupByType('DESIGNATION');
      this.Lookups.PurposeOfRelationshipLkp = this.lookupService.getLookupByType('PURPOSE_OF_ACCOUNT');
      this.Lookups.AccountTypeLkp = this.lookupService.getLookupByType('ID Type');
      this.Lookups.EStatementFrequencyLkp = this.lookupService.getLookupByType('ESTATEMENT_FREQUENCY');
      this.Lookups.Residences = CommonHelper.OrderArrayByProperty(this.lookupService.getLookupByType('COUNTRIES'), ['VisibleValue'], ['asc']);
      this.Lookups.MonthlyCreditTransactionsLkp = this.lookupService.getLookupByType('YES_NO_BIT');
      this.Lookups.MonthlyCreditTurnoverLkp = this.lookupService.getLookupByType('YES_NO_BIT');
      this.Lookups.NationalityLkp = this.lookupService.getLookupByType('YES_NO_BIT');
      this.Lookups.CountryOfResidenceLkp = this.lookupService.getLookupByType('YES_NO_BIT');
      this.Lookups.GenderLkp = this.lookupService.getLookupByType('GENDER');
      this.Lookups.ResidentStatusLkp = this.lookupService.getLookupByType('DAO_RESIDENT_STATUS').filter(x => x.IsActive == 1);
      this.Lookups.OccupationLkp = this.lookupService.getLookupByType('FORM_OCCUPATIONS');
      this.Lookups.ProfessionLkp = this.lookupService.getLookupByType('OCCUPATIONS');
      this.Lookups.IncomeSource = this.lookupService.getLookupByType('SOURCE_OF_INCOME');
      this.Lookups.AddressTypes = this.lookupService.getLookupByType('ADDRESS_TYPE');
      this.Lookups.DocumentTypes = this.lookupService.getLookupByType('IdentificationDocumentTypes');
      this.Lookups.JobTitle = this.lookupService.getLookupByType('JOB_TITLE');
      this.Lookups.AccountTypes = this.lookupService.getLookupByType('DAO_ACCOUNT_TYPE');


      this.Lookups.RACProductType = this.lookupService.getLookupByType('RAC_PRODUCT_TYPE');
      this.Lookups.PricingMarkupType = this.lookupService.getLookupByType('RAC_PRICING_MARKUP_TYPE');
      this.Lookups.CarType = this.lookupService.getLookupByType('CAR_TYPE');
      this.Lookups.BookingType = this.lookupService.getLookupByType('BOOKING_TYPE');
      this.Lookups.LoanTenure = this.lookupService.getLookupByType('LOAN_TENURE');
      this.Lookups.InsuranceCompany = this.lookupService.getLookupByType('INSURANCE_COMPANY');
      this.Lookups.TrackerAvailability = this.lookupService.getLookupByType('TRACKER_AVAILABILITY');
      this.filteredTrackerList = this.Lookups.TrackerAvailability;
      this.Lookups.RelationWithApplicant = this.lookupService.getLookupByType('RELATION_WITH_APPLICANT');
      this.Lookups.EmploymentDetails = this.lookupService.getLookupByType('EMPLOYMENT_DETAILS');
      this.Lookups.MakeModel = this.lookupService.getLookupByType('MAKE_MODEL');

      this.LookupForDeclaration = this.Lookups;

    });
  }
  fetchBranchList(data) {
    if (data['TmxCustomerMaster'][0].TmxCustomerDetail && data['TmxCustomerMaster'][0].TmxCustomerDetail[0] && data['TmxCustomerMaster'][0].TmxCustomerDetail[0].TmxPerson) {
      if (data['TmxCustomerMaster'][0].TmxCustomerDetail[0].TmxPerson.PersonCurrentCityUDF) {
        this.onCitySelected(data['TmxCustomerMaster'][0].TmxCustomerDetail[0].TmxPerson.PersonCurrentCityUDF);
      }
    }
  }
  formSubmit(form) {
    console.log(this.model);
    console.log(form);
  }
  performValidationsForSubmit() {
    let errorMessage: string = null;
    errorMessage = this.getValidationErrorMessage();
    if (CommonHelper.Exists(errorMessage)) {
      this.toastr.error(errorMessage, "Validation Failed", {
        timeOut: 6500
      });
      return false;
    }
    console.log(this.accountAppModel);
    console.log(this.documentAttachmentComponent);
    return true;

  }
  getValidationErrorMessage() {

    if (!CommonHelper.Exists(this.accountAppModel, 'TmxLoanApplicationChecklist') || this.accountAppModel['TmxLoanApplicationChecklist'].length == 0) {
      return 'Please upload the supporting documents in document section to submit';
    }
    let attachedChecklists = this.accountAppModel['TmxLoanApplicationChecklist'].filter(x => x.uploaded || x.AttachmentURL).map(x => '' + x.LoanProductChecklistId);// convert to string Jugar
    let documentGroupsToValidate = Array.from(new Set(this.documentAttachmentComponent.Checklists.filter(x => x.group != 'Optional').map(x => x.group)));
    for (let i = 0; i < documentGroupsToValidate.length; i++) {
      var docGroup = documentGroupsToValidate[i];
      let documentIds = this.documentAttachmentComponent.Checklists.filter(x => x.group == docGroup).map(x => x.id);
      let docFound = documentIds.some(x => attachedChecklists.includes('' + x));
      if (!docFound) {
        return `Supporting documents not found for ${docGroup}`;
      }
    };


    return null;
  }
  addPurpose(event: Event) {
    if (this.addPurposeOne === true && this.addPurposeTwo !== true) {
      this.addPurposeTwo = true;
    } else {
      this.addPurposeOne = true;
    }
    event.preventDefault();
  }

  removePurposetwo(event: Event) {
    this.addPurposeTwo = false;
    this.accountAppModel.PurposeOfAccountTwoUDF = null;
    event.preventDefault();

  }
  removePurposeOne(event: Event) {
    this.addPurposeOne = false;
    this.accountAppModel.PurposeOfAccountOneUDF = null;
    event.preventDefault();

  }
  addOfficeNumber(event: Event) {

    this.OfficeNumber = true;

    event.preventDefault();
  }
  removeOfficeNumber(event: Event, index) {
    this.OfficeNumber = false;
    this.applicantDetails[index].ContactNumberOfficeUDF = null;
    // this.accountAppModel['ContactNumberOfficeUDF'] = null;
    event.preventDefault();

  }
  addResidenceNumber(event: Event) {

    this.ResidenceNumber = true;
    event.preventDefault();
  }
  removeResidenceNumber(event: Event, index) {
    this.ResidenceNumber = false;
    this.applicantDetails[index].LandlineNumber = null;
    // this.accountAppModel['LandlineNumber'] = null;
    event.preventDefault();

  }
  async readAccountApplication(searchRequest) {
    this.loaderService.start();
    await this.applicationService.readApplication(searchRequest).toPromise()
      .then(response => {
        this.loaderService.stop();
        if (response && response.data) {
          // this.applicationService.readApplicationById(response.data.accountApplicationID).subscribe(res => {
          return response.data;

          // });
        }
      })
      .catch(async (error) => {
        this.loaderService.stop();
        console.log(error);
      });
  }
  bindAccountAppModel() {
    this.accountModel = this.accountAppModel;
    this.accountModel.AccountNumber = null;
    this.accountModel['TmxCustomerMaster'] = [];
    this.accountModel["TmxApplicationDetail"] = [];
    this.accountModel["TmxApplicationDetail"][0] = {};
    this.accountModel["TmxApplicationDetail"][0].UseMobileNumberAsUsername ="0";

    // this.accountModel['TmxLoanApplicationChecklist'] = [];
    // this.accountModel['TmxLoanApplicationChecklist'] = this.accountAppModel['TmxLoanApplicationChecklist'];
    this.accountModel['TmxCustomerMaster'][0] = {};
    this.accountModel['ProductId'] = this.appConfig.ProductId; // hardcoded for demo 89
    this.accountModel['TmxCustomerMaster'][0].IPAddress=this.accountAppModel["IPAddress"];
    this.accountModel['TmxCustomerMaster'][0].IPLocation=this.accountAppModel["IPLocation"];
    this.accountModel['TmxCustomerMaster'][0].RefNo = DataService.get("RefNo");

    if(this.lookupService.Brancheslookups.filter(br=>br.BranchName == this.accountAppModel.Branch).map(br=>br.CompanyBranchId)){
      this.accountModel['CompanyBranchId'] = this.lookupService.Brancheslookups.filter(br=>br.BranchName == this.accountAppModel.Branch).map(br=>br.CompanyBranchId)[0];
    }else{
      this.accountModel['CompanyBranchId'] = this.appConfig.CompanyBranchId; // hardcoded for demo 1018
    }

    if (this.accountModel.AccountApplicationNumber) {
      this.accountModel['TmxCustomerMaster'][0].AccountNumber = this.accountModel.AccountApplicationNumber;

    }
    if (this.accountAppModel['PrimaryApplicantName']) {
      this.accountModel['TmxCustomerMaster'][0].PrimaryApplicantName = this.accountAppModel['PrimaryApplicantName'];
      this.accountModel['TmxCustomerMaster'][0].CustomerName = this.accountAppModel['PrimaryApplicantName'];
      this.accountModel['AccountName'] = this.accountAppModel['PrimaryApplicantName'];
    }
    if (this.accountAppModel['EmailAddress']) {
      this.accountModel['TmxCustomerMaster'][0].EmailUDF = this.accountAppModel['EmailAddress'];
    }
    if (this.accountAppModel['RACProductType']) {
      this.accountModel['TmxCustomerMaster'][0].RACProductType = this.accountAppModel['RACProductType'];
    }
    if (this.accountAppModel['PricingMarkupType']) {
      this.accountModel['TmxCustomerMaster'][0].PricingMarkupType = this.accountAppModel['PricingMarkupType'];
    }
    if (this.accountAppModel['CarType']) {
      this.accountModel['TmxCustomerMaster'][0].CarType = this.accountAppModel['CarType'];
    }
    if (this.accountAppModel['BookingType']) {
      this.accountModel['TmxCustomerMaster'][0].BookingType = this.accountAppModel['BookingType'];
    }
    if (this.accountAppModel['MakeModel']) {
      this.accountModel['TmxCustomerMaster'][0].MakeModel = this.accountAppModel['MakeModel'];
    }
    if (this.accountAppModel['CarPrice']) {
      this.accountModel['TmxCustomerMaster'][0].CarPrice = this.accountAppModel['CarPrice'];
    }
    if (this.accountAppModel['BusinessAddress']) {
      this.accountModel['TmxCustomerMaster'][0].BusinessAddress = this.accountAppModel['BusinessAddress'];
    }

    if (this.accountAppModel['DownPaymentPercentage']) {
      this.accountModel['TmxCustomerMaster'][0].DownPaymentPercentage = this.accountAppModel['DownPaymentPercentage'];
    }if (this.accountAppModel['FinancingAmount']) {
      this.accountModel['TmxCustomerMaster'][0].FinancingAmount = this.accountAppModel['FinancingAmount'];
    }if (this.accountAppModel['LoanTenure']) {
      this.accountModel['TmxCustomerMaster'][0].LoanTenure = this.accountAppModel['LoanTenure'];
    }if (this.accountAppModel['InsuranceCompany']) {
      this.accountModel['TmxCustomerMaster'][0].InsuranceCompany = this.accountAppModel['InsuranceCompany'];
    }if (this.accountAppModel['AddOn1']) {
      this.accountModel['TmxCustomerMaster'][0].AddOn1 = this.accountAppModel['AddOn1'];
    }if (this.accountAppModel['TrackerAvailability']) {
      this.accountModel['TmxCustomerMaster'][0].TrackerAvailability = this.accountAppModel['TrackerAvailability'];
    }if (this.accountAppModel['IsSalaried']) {
      this.accountModel['TmxCustomerMaster'][0].IsSalaried = this.accountAppModel['IsSalaried'];
    }
    if (this.accountAppModel['EmployeeName']) {
      this.accountModel['TmxCustomerMaster'][0].EmployeeName = this.accountAppModel['EmployeeName'];
    }if (this.accountAppModel['EmployeeSince']) {
      this.accountModel['TmxCustomerMaster'][0].EmployeeSince = this.accountAppModel['EmployeeSince'];
    }if (this.accountAppModel['NameOfBusiness']) {
      this.accountModel['TmxCustomerMaster'][0].NameOfBusiness = this.accountAppModel['NameOfBusiness'];
    }if (this.accountAppModel['StatusOfBusiness']) {
      this.accountModel['TmxCustomerMaster'][0].StatusOfBusiness = this.accountAppModel['StatusOfBusiness'];
    }if (this.accountAppModel['YearsInBusiness']) {
      this.accountModel['TmxCustomerMaster'][0].YearsInBusiness = this.accountAppModel['YearsInBusiness'];
    }if (this.accountAppModel['Other']) {
      this.accountModel['TmxCustomerMaster'][0].Other = this.accountAppModel['Other'];
    }if (this.accountAppModel['CoBorrowerName']) {
      this.accountModel['TmxCustomerMaster'][0].CoBorrowerName = this.accountAppModel['CoBorrowerName'];
    }if (this.accountAppModel['CNIC']) {
      this.accountModel['TmxCustomerMaster'][0].CNIC = this.accountAppModel['CNIC'];
    }if (this.accountAppModel['ContactNumberPak']) {
      this.accountModel['TmxCustomerMaster'][0].ContactNumberPak = this.accountAppModel['ContactNumberPak'];
    }if (this.accountAppModel['RelationWithApplicant']) {
      this.accountModel['TmxCustomerMaster'][0].RelationWithApplicant = this.accountAppModel['RelationWithApplicant'];
    }


    if (this.accountAppModel['AccountTitle']) {
      this.accountModel['TmxCustomerMaster'][0].AccountTitle = this.accountAppModel['AccountTitle'];
    }if (this.accountAppModel['Address']) {
      this.accountModel['TmxCustomerMaster'][0].Address = this.accountAppModel['Address'];
    }if (this.accountAppModel['CounteryName']) {
      this.accountModel['TmxCustomerMaster'][0].CounteryName = this.accountAppModel['CounteryName'];
    }if (this.accountAppModel['OffPhone']) {
      this.accountModel['TmxCustomerMaster'][0].OffPhone = this.accountAppModel['OffPhone'];
    }if (this.accountAppModel['JobType']) {
      this.accountModel['TmxCustomerMaster'][0].JobType = this.accountAppModel['JobType'];
    }if (this.accountAppModel['Salary']) {
      this.accountModel['TmxCustomerMaster'][0].Salary = this.accountAppModel['Salary'];
    }if (this.accountAppModel['Branch']) {
      this.accountModel['TmxCustomerMaster'][0].Branch = this.accountAppModel['Branch'];
    }if (this.accountAppModel['IBAN']) {
      this.accountModel['TmxCustomerMaster'][0].AccountNumber = this.accountAppModel['IBAN'];
    }







    //this.bindApplicantObject();
  }

  mapApplicantToCustomerObject(applicant: applicantDetailsModel, mainCustomerObj, personObj) {
    //'ContactNumber'
    masterFieldNames.forEach(key => {
      if (Object.prototype.hasOwnProperty.call(applicant, key)) {
        mainCustomerObj[key] = applicant[key];
      }
    });
    personFieldNames.forEach(key => {
      if (Object.prototype.hasOwnProperty.call(applicant, key)) {
        personObj[key] = applicant[key];
      }
    });

    if (applicant.TmxGuarantorChecklist) {
      if (!mainCustomerObj.TmxGuarantorChecklist) {
        mainCustomerObj.TmxGuarantorChecklist = [];
      }
      for (let i = 0; i < applicant.TmxGuarantorChecklist.length; i++) {
        if (!mainCustomerObj.TmxGuarantorChecklist[i]) {
          mainCustomerObj.TmxGuarantorChecklist[i] = {};
        }
        Object.keys(applicant.TmxGuarantorChecklist[i]).forEach(key => mainCustomerObj.TmxGuarantorChecklist[i][key] = applicant.TmxGuarantorChecklist[i][key]);
      }
    }

    if (applicant.TmxPersonProfessionDetail) {
      if (!personObj.TmxPersonProfessionDetail) {
        personObj.TmxPersonProfessionDetail = [];
      }
      for (let i = 0; i < applicant.TmxPersonProfessionDetail.length; i++) {
        if (!personObj.TmxPersonProfessionDetail[i]) {
          personObj.TmxPersonProfessionDetail[i] = {};
        }
        Object.keys(applicant.TmxPersonProfessionDetail[i]).forEach(key => personObj.TmxPersonProfessionDetail[i][key] = applicant.TmxPersonProfessionDetail[i][key]);
      }
    }
    if (applicant.TmxPersonNationalIdentifier) {
      if (!personObj.TmxPersonNationalIdentifier) {
        personObj.TmxPersonNationalIdentifier = [];
      }
      for (let i = 0; i < applicant.TmxPersonNationalIdentifier.length; i++) {
        if (!personObj.TmxPersonNationalIdentifier[i]) {
          personObj.TmxPersonNationalIdentifier[i] = {};
        }
        Object.keys(applicant.TmxPersonNationalIdentifier[i]).forEach(key => personObj.TmxPersonNationalIdentifier[i][key] = applicant.TmxPersonNationalIdentifier[i][key]);
      }
    }

    var TotalIncomeAmountUDF = 0;
    if (applicant.TmxPersonIncomeDetail) {
      if (!personObj.TmxPersonIncomeDetail) {
        personObj.TmxPersonIncomeDetail = [];
      }
      for (let i = 0; i < applicant.TmxPersonIncomeDetail.length; i++) {
        if (applicant.TmxPersonIncomeDetail[i].IncomeSourceLkp && applicant.TmxPersonIncomeDetail[i].MonthlyIncomeAmount) {
          TotalIncomeAmountUDF += Number.parseInt(applicant.TmxPersonIncomeDetail[i].MonthlyIncomeAmount || 0);
          if (!personObj.TmxPersonIncomeDetail[i]) {
            personObj.TmxPersonIncomeDetail[i] = {};
          }
          Object.keys(applicant.TmxPersonIncomeDetail[i]).forEach(key => personObj.TmxPersonIncomeDetail[i][key] = applicant.TmxPersonIncomeDetail[i][key]);
        }
      }
    }
    mainCustomerObj.TotalIncomeAmountUDF = TotalIncomeAmountUDF;

    if (applicant.fatca) {
      if (!mainCustomerObj.TmxCustomerFatcaDetail) {
        mainCustomerObj.TmxCustomerFatcaDetail = [];
      }
      for (let i = 0; i < applicant.fatca.length; i++) {
        if (!mainCustomerObj.TmxCustomerFatcaDetail[i]) {
          mainCustomerObj.TmxCustomerFatcaDetail[i] = {};
        }
        Object.keys(applicant.fatca[i]).forEach(key => mainCustomerObj.TmxCustomerFatcaDetail[i][key] = applicant.fatca[i][key]);
      }
    }
    if (applicant.crsDetails) {
      if (!mainCustomerObj.TmxCrsDetail) {
        mainCustomerObj.TmxCrsDetail = [];
      }
      for (let i = 0; i < applicant.crsDetails.length; i++) {
        if (!mainCustomerObj.TmxCrsDetail[i]) {
          mainCustomerObj.TmxCrsDetail[i] = {};
        }
        Object.keys(applicant.crsDetails[i]).forEach(key => mainCustomerObj.TmxCrsDetail[i][key] = applicant.crsDetails[i][key]);
      }
    }

    // Nationality
    let nationalityFields = ['PersonNationalityLkp', 'N2UDF1', 'N2UDF2'];
    for (let i = 0; i < applicant.nationality.length; i++) {
      personObj[nationalityFields[i]] = applicant.nationality[i].nationalityLkp;
    }
  }

  bindApplicantObject() {
    if (!this.accountModel['TmxCustomerMaster'][0].TmxCustomerDetail || !this.accountModel['TmxCustomerMaster'][0].TmxCustomerDetail[0]) {
      this.accountModel['TmxCustomerMaster'][0].TmxCustomerDetail = [{}];
    }
    if (!this.accountModel['TmxCustomerMaster'][0].TmxCustomerDetail[0].TmxPerson) {
      this.accountModel['TmxCustomerMaster'][0].TmxCustomerDetail[0].TmxPerson = {};
      this.accountModel['TmxCustomerMaster'][0].TmxCustomerDetail[0].TmxPerson.PersonFirstName = '';
    }
    if (!this.accountModel['TmxLoanApplicationToGuarantorMapping']) {
      this.accountModel['TmxLoanApplicationToGuarantorMapping'] = [];
    }

    for (let index = 0; index < this.applicantDetails.length; index++) {
      const applicant = this.applicantDetails[index];
      if (index == 0) {
        this.mapApplicantToCustomerObject(applicant, this.accountModel['TmxCustomerMaster'][0], this.accountModel['TmxCustomerMaster'][0].TmxCustomerDetail[0].TmxPerson)
      }
      else {
        //can get by guarantorId
        let guarantorMappingObj = this.accountModel['TmxLoanApplicationToGuarantorMapping'][index - 1];
        if (!guarantorMappingObj || !guarantorMappingObj.TmxGuarantor) {
          this.accountModel['TmxLoanApplicationToGuarantorMapping'][index - 1] = { TmxGuarantor: {} };
        }
        if (!this.accountModel['TmxLoanApplicationToGuarantorMapping'][index - 1].TmxGuarantor.TmxPerson) {
          this.accountModel['TmxLoanApplicationToGuarantorMapping'][index - 1].TmxGuarantor.TmxPerson = {};
          this.accountModel['TmxLoanApplicationToGuarantorMapping'][index - 1].TmxGuarantor.TmxPerson.PersonFirstName = '';
        }
        this.mapApplicantToCustomerObject(applicant, this.accountModel['TmxLoanApplicationToGuarantorMapping'][index - 1].TmxGuarantor, this.accountModel['TmxLoanApplicationToGuarantorMapping'][index - 1].TmxGuarantor.TmxPerson)
      }
    }
    // General Customer Master and person fields
    this.accountModel['TmxCustomerMaster'][0].TmxCustomerDetail[0].TmxPerson.PersonCurrentCityUDF = this.accountAppModel['PersonCurrentCityUDF'];

    console.log(this.accountModel);


  }



  setIds(data) {
    var coreFields = ['AccountApplicationId', 'CreatedBy', 'AccountApplicationNumber', 'AccountOpeningRequestDate', 'AccountName'
      , 'ProcessInstanceId', 'ApplicationStatusLkp'];

    coreFields.forEach(function (field) {
      this.accountAppModel[field] = data[field];
    }.bind(this));

    if (data['TmxCustomerMaster'] && data['TmxCustomerMaster'][0]) {
      if (!this.accountAppModel['TmxCustomerMaster']) {
        this.accountAppModel['TmxCustomerMaster'] = [];
        this.accountAppModel['TmxCustomerMaster'][0] = {};
      }
      this.accountAppModel['TmxCustomerMaster'][0]['CustomerMasterId'] = data['TmxCustomerMaster'][0]['CustomerMasterId'];
      this.accountAppModel['TmxCustomerMaster'][0]['CreatedBy'] = data['TmxCustomerMaster'][0]['CreatedBy'];


      if (data['TmxLoanApplicationChecklist'] && this.accountAppModel['TmxLoanApplicationChecklist']) {
        data['TmxLoanApplicationChecklist'].forEach(function (checklist) {
          var matchingChecklistItem = this.accountAppModel['TmxLoanApplicationChecklist'].find(x => x.LoanProductChecklistId == checklist.LoanProductChecklistId);
          if (matchingChecklistItem) {
            matchingChecklistItem.LoanApplicationChecklistId = checklist.LoanApplicationChecklistId;
            matchingChecklistItem.CreatedBy = checklist.CreatedBy;
          }
        }.bind(this));
      }


    }
  }

  setModelFromData(data) {

    //existing draft application fields
    if(DataService.get('IsOld') == '1'){
      this.oldApp = true;
    }else{
      this.oldApp = false;
    }

    if(this.oldApp){

      if (DataService.get('Checklist')) {
        this.accountAppModel['TmxLoanApplicationChecklist'] = DataService.get('Checklist');

      }
      if (data['PrimaryApplicantName']) {

        this.accountAppModel.PrimaryApplicantName = data['PrimaryApplicantName'];
        this.accountAppModel.AccountName = data['PrimaryApplicantName'];
      }
      if (data['RACProductType']) {

        this.accountAppModel.RACProductType = data['RACProductType'];
      } if (data['PricingMarkupType']) {

        this.accountAppModel.PricingMarkupType = data['PricingMarkupType'];
      } if (data['CarType']) {

        this.accountAppModel.CarType = data['CarType'];
        if(this.Lookups.CarType.filter(x => x.LookupId == this.accountAppModel.CarType).map(y=>y.HiddenValue) == 'New'){
          this.newCar = true;
        }else{
          this.newCar = false;
        }
      } if (data['BookingType']) {

        this.accountAppModel.BookingType = data['BookingType'];
      } if (data['MakeModel']) {

        this.accountAppModel.MakeModel = data['MakeModel'];
      } if (data['CarPrice']) {

        this.accountAppModel.CarPrice = data['CarPrice'];
      }if (data['CNIC']) {

        this.accountAppModel.CNIC = data['CNIC'];
      }
       if (data['DownPaymentPercentage']) {

        this.accountAppModel.DownPaymentPercentage = data['DownPaymentPercentage'];
      } if (data['FinancingAmount']) {

        this.accountAppModel.FinancingAmount = data['FinancingAmount'];
      } if (data['LoanTenure']) {

        this.accountAppModel.LoanTenure = data['LoanTenure'];
      } if (data['InsuranceCompany']) {

        this.accountAppModel.InsuranceCompany = data['InsuranceCompany'];
      } if (data['AddOn1']) {

        this.accountAppModel.AddOn1 = data['AddOn1'];
      } if (data['TrackerAvailability']) {

        this.accountAppModel.TrackerAvailability = data['TrackerAvailability'];
      } if (data['IsSalaried']) {

        this.accountAppModel.IsSalaried = data['IsSalaried'];
        this.onEmploymentSelected(this.accountAppModel.IsSalaried);
      } if (data['Other']) {

        this.accountAppModel.Other = data['Other'];
      } if (data['EmployeeName']) {

        this.accountAppModel.EmployeeName = data['EmployeeName'];
      }if (data['EmployeeSince']) {

        this.accountAppModel.EmployeeSince = data['EmployeeSince'];
      }if (data['NameOfBusiness']) {

        this.accountAppModel.NameOfBusiness = data['NameOfBusiness'];
      }if (data['YearsInBusiness']) {

        this.accountAppModel.YearsInBusiness = data['YearsInBusiness'];
      }if (data['CoBorrowerName']) {

        this.accountAppModel.CoBorrowerName = data['CoBorrowerName'];
      }if (data['ContactNumberPak']) {

        this.accountAppModel.ContactNumberPak = data['ContactNumberPak'];
      }if (data['RelationWithApplicant']) {

        this.accountAppModel.RelationWithApplicant = data['RelationWithApplicant'];
      }
      if (data['AccountApplicationId']) {

        this.accountAppModel.AccountApplicationId = data['AccountApplicationId'];
      }

      if (data['AccountTitle']) {

        this.accountAppModel.PrimaryApplicantName = data['AccountTitle'];
        this.accountAppModel.AccountTitle = data['AccountTitle'];
        this.accountAppModel.AccountName = data['AccountTitle'];

      }
      if (data['EmployeeName']) {

        this.accountAppModel.EmployeeName = data['EmployeeName'];
      }
      if (data['Address']) {

        this.accountAppModel.Address = data['Address'];
        //this.accountAppModel.BusinessAddress = data['Address'];
      }
      if (data['BusinessAddress']) {


        this.accountAppModel.BusinessAddress = data['BusinessAddress'];
      }
      if (data['CounteryName']) {

        this.accountAppModel.CounteryName = data['CounteryName'];
      }
      if (data['AccountNumber']) {

        this.accountAppModel.IBAN = data['AccountNumber'];
        this.accountAppModel.AccountNumber = data['AccountNumber'];
      }

      if (data['OffPhone']) {

        this.accountAppModel.OffPhone = data['OffPhone'];
      }
      if (data['EmailAddress']) {

        this.accountAppModel.EmailAddress = data['EmailAddress'];
      }

      if (data['JobType']) {

        this.accountAppModel.JobType = data['JobType'];
      }
      if (data['Salary']) {

        this.accountAppModel.Salary = data['Salary'];
      }if (data['Branch']) {

        this.accountAppModel.Branch = data['Branch'];
      }


    }
    else{
//RDA auto populate fields
if (data['AccountTitle']) {

  this.accountAppModel.PrimaryApplicantName = data['AccountTitle'];
  this.accountAppModel.AccountTitle = data['AccountTitle'];

}
if(data['OccType']=='BUSINESS' && data['EmpName']){
  this.accountAppModel.NameOfBusiness = data['EmpName'];
}
else if (data['OccType']=='SALARIED' && data['EmpName']) {

  this.accountAppModel.EmployeeName = data['EmpName'];
}else{
  this.accountAppModel.Other = data['EmpName'];
}
if (data['Address']) {

  this.accountAppModel.Address = data['Address'];
  this.accountAppModel.BusinessAddress = data['Address'];
}
if (data['BusinessAddress']) {


  this.accountAppModel.BusinessAddress = data['BusinessAddress'];
}
if (data['CounteryName']) {

  this.accountAppModel.CounteryName = data['CounteryName'];
}
if (data['IBAN']) {

  this.accountAppModel.IBAN = data['IBAN'];
  this.accountAppModel.AccountNumber = data['IBAN'];
}

if (data['Sms1']) {

  this.accountAppModel.OffPhone = data['Sms1'];
}
if (data['Email1']) {

  this.accountAppModel.EmailAddress = data['Email1'];
}

if (data['JobType']) {

  this.accountAppModel.JobType = data['JobType'];
}
if (data['Sal']) {

  this.accountAppModel.Salary = data['Sal'];
}if (data['CompanyBook']) {
  this.accountAppModel.Branch = this.lookupService.Brancheslookups.filter(br=>br.BranchCode == data['CompanyBook']).map(br=>br.BranchName)[0];
  //this.accountAppModel.Branch = data['CompanyBook'];
}


    }

    //this.setApplicantModel();
  }
  setApplicantModel() {
    if (this.accountAppModel['TmxCustomerMaster'] && this.accountAppModel['TmxCustomerMaster'][0]) {
      if (!this.accountAppModel['TmxCustomerMaster'][0].TmxCustomerDetail || !this.accountAppModel['TmxCustomerMaster'][0].TmxCustomerDetail[0]) {
        this.accountAppModel['TmxCustomerMaster'][0].TmxCustomerDetail = [{}];
      }
      if (!this.accountAppModel['TmxCustomerMaster'][0].TmxCustomerDetail[0].TmxPerson) {
        this.accountAppModel['TmxCustomerMaster'][0].TmxCustomerDetail[0].TmxPerson = {};
      }
      if (!this.applicantDetails[0]) {
        this.applicantDetails.push(this.getNewApplicantDetailObject());
      }
      this.bindExistingDataToApplicant(this.applicantDetails[0], this.accountAppModel['TmxCustomerMaster'][0], this.accountAppModel['TmxCustomerMaster'][0].TmxCustomerDetail[0].TmxPerson)
    }
    if (this.accountAppModel['TmxLoanApplicationToGuarantorMapping']) {
      for (let i = 0; i < this.accountAppModel['TmxLoanApplicationToGuarantorMapping'].length; i++) {
        if (!this.accountAppModel['TmxLoanApplicationToGuarantorMapping'][i].TmxGuarantor) {
          this.accountAppModel['TmxLoanApplicationToGuarantorMapping'][i].TmxGuarantor = {};
        }
        if (!this.accountAppModel['TmxLoanApplicationToGuarantorMapping'][i].TmxGuarantor.TmxPerson) {
          this.accountAppModel['TmxLoanApplicationToGuarantorMapping'][i].TmxGuarantor.TmxPerson = {};
        }
        let applicantObject = this.getNewApplicantDetailObject();
        this.bindExistingDataToApplicant(applicantObject, this.accountAppModel['TmxLoanApplicationToGuarantorMapping'][i].TmxGuarantor, this.accountAppModel['TmxLoanApplicationToGuarantorMapping'][i].TmxGuarantor.TmxPerson)
        this.applicantDetails.push(applicantObject);
      }
    }
  }
  bindExistingDataToApplicant(applicant: applicantDetailsModel, mainCustomerObj, personObj) {
    masterFieldNames.forEach(key => {
      if (Object.prototype.hasOwnProperty.call(mainCustomerObj, key)) {
        applicant[key] = mainCustomerObj[key];
      }
    });
    personFieldNames.forEach(key => {
      if (Object.prototype.hasOwnProperty.call(personObj, key)) {
        applicant[key] = personObj[key];
      }
    });

    if (mainCustomerObj.TmxGuarantorChecklist) {
      if (!applicant.TmxGuarantorChecklist) {
        applicant.TmxGuarantorChecklist = [];
      }
      for (let i = 0; i < mainCustomerObj.TmxGuarantorChecklist.length; i++) {
        if (!applicant.TmxGuarantorChecklist[i]) {
          applicant.TmxGuarantorChecklist[i] = {};
        }
        Object.keys(mainCustomerObj.TmxGuarantorChecklist[i]).forEach(key => applicant.TmxGuarantorChecklist[i][key] = mainCustomerObj.TmxGuarantorChecklist[i][key]);
      }
    }

    if (personObj.TmxPersonProfessionDetail) {
      if (!applicant.TmxPersonProfessionDetail) {
        applicant.TmxPersonProfessionDetail = [];
      }
      for (let i = 0; i < personObj.TmxPersonProfessionDetail.length; i++) {
        if (!applicant.TmxPersonProfessionDetail[i]) {
          applicant.TmxPersonProfessionDetail[i] = {};
        }
        Object.keys(personObj.TmxPersonProfessionDetail[i]).forEach(key => applicant.TmxPersonProfessionDetail[i][key] = personObj.TmxPersonProfessionDetail[i][key]);
      }
    }

    if (personObj.TmxPersonIncomeDetail) {
      if (!applicant.TmxPersonIncomeDetail) {
        applicant.TmxPersonIncomeDetail = [];
      }
      for (let i = 0; i < personObj.TmxPersonIncomeDetail.length; i++) {
        if (!applicant.TmxPersonIncomeDetail[i]) {
          applicant.TmxPersonIncomeDetail[i] = {};
        }
        Object.keys(personObj.TmxPersonIncomeDetail[i]).forEach(key => applicant.TmxPersonIncomeDetail[i][key] = personObj.TmxPersonIncomeDetail[i][key]);
      }
    }

    if (personObj.TmxPersonNationalIdentifier) {
      if (!applicant.TmxPersonNationalIdentifier) {
        applicant.TmxPersonNationalIdentifier = [];
      }
      for (let i = 0; i < personObj.TmxPersonNationalIdentifier.length; i++) {
        if (!applicant.TmxPersonNationalIdentifier[i]) {
          applicant.TmxPersonNationalIdentifier[i] = new DocumentDetailsModel();
        }
        Object.keys(personObj.TmxPersonNationalIdentifier[i]).forEach(key => applicant.TmxPersonNationalIdentifier[i][key] = personObj.TmxPersonNationalIdentifier[i][key]);
      }
    }
    if (mainCustomerObj.TmxCustomerFatcaDetail) {
      if (!applicant.fatca) {
        applicant.fatca = [];
      }
      for (let i = 0; i < mainCustomerObj.TmxCustomerFatcaDetail.length; i++) {
        if (!applicant.fatca[i]) {
          applicant.fatca[i] = new FatcaDetailsModel();
        }
        Object.keys(mainCustomerObj.TmxCustomerFatcaDetail[i]).forEach(key => applicant.fatca[i][key] = mainCustomerObj.TmxCustomerFatcaDetail[i][key]);
      }
    }
    if (mainCustomerObj.TmxCrsDetail) {
      if (!applicant.crsDetails) {
        applicant.crsDetails = [];
      }
      for (let i = 0; i < mainCustomerObj.TmxCrsDetail.length; i++) {
        if (!applicant.crsDetails[i]) {
          applicant.crsDetails[i] = new crsDetailsModel();
        }
        Object.keys(mainCustomerObj.TmxCrsDetail[i]).forEach(key => applicant.crsDetails[i][key] = mainCustomerObj.TmxCrsDetail[i][key]);
      }
    }
    /// Nationality array
    applicant.nationality[0].nationalityLkp = personObj['PersonNationalityLkp'];
    let nationalityFields = ['N2UDF1', 'N2UDF2'];
    nationalityFields.forEach(key => {
      if (personObj[key]) {
        let nationalityItem = new NationalityModel();
        nationalityItem.nationalityLkp = personObj[key];
        applicant.nationality.push(nationalityItem);
      }
    });
  }


  cancelClick() {

    console.log(this.accountAppModel["TmxApplicationDetail"][0]);
  }
  onTNCchange(data) {
    this.showSubmit = data;
    this.firebase.logEvent('I Agree with TnCs');
  }
  onFinchange(data) {
    // if(data < 1 ){
    //   this.accountAppModel.CarPrice = 0;
    //   this.accountAppModel.DownPaymentPercentage = 0;
    // }
    this.accountAppModel.FinancingAmount = this.accountAppModel.CarPrice - (this.accountAppModel.CarPrice*(this.accountAppModel.DownPaymentPercentage/100));
    this.firebase.logEvent('car financing calc');
  }

  goToNextStep(stepper: MatStepper) {
        if(this.smallScreen)
    { console.log("Inside");
      const stepId = stepper._getStepLabelId(stepper.selectedIndex);
      const stepElement = document.getElementById(stepId);
      if (stepElement) {
        stepElement.scrollIntoView({ block: 'start', inline: 'nearest', behavior: 'smooth' });
      }
    }
    let valid = this.manualChecks(stepper);
    if (!valid) {
      stepper.selected.interacted = true;
      return;
    }
    var switched = stepper.next();
    const app = document.getElementsByClassName("mat-step-label mat-step-label-active mat-step-label-selected");
    console.log(app[0]);

    switch(app[0]['innerText'])
    {
      case 'Basic Account Details':
        this.firebase.logEvent('Navigation | Applicant Details');
        break;

      case 'Applicant Details':
        this.firebase.logEvent('Navigation | Next Of KIN');
        break;

      case 'Next Of Kin':
        this.firebase.logEvent('Navigation | Income and Bank Details');
        break;

      case 'Income and Bank Details':
        this.firebase.logEvent('Navigation | Documents');
        break;

      case 'Documents':
        this.firebase.logEvent('Navigation | Declarations');
        break;

      default :
        this.firebase.logEvent('Navigation | Basic Account Details');
        break;

    }

    this.postDetails('save', true);
  }



  manualChecks(stepper: MatStepper): boolean {
    let valid = true;
    if (stepper.selectedIndex == 0) {// Basic Account Details
      if (!(this.IsAccountSelected)) {
        valid = false;
      }
      else {
        let selectedAccountTypes = [this.accountAppModel.AccountTypeLkp1, this.accountAppModel.AccountTypeLkp2, this.accountAppModel.AccountTypeLkp3, this.accountAppModel.AccountTypeLkp4, this.accountAppModel.AccountTypeLkp5];
        let nonEmptyAccountTypes = selectedAccountTypes.filter(x => x != null || x != undefined);
        let duplicates = CommonHelper.FindDuplicateInArray(nonEmptyAccountTypes);
        if (duplicates && duplicates.length > 0) {
          valid = false;
          this.toastr.error("Duplicate account types are not allowed");
        }
      }
    }
    if (stepper.selectedIndex == 1) { // Applicant details
      if (this.showMultipleApplicants) {
        if (this.ApplicantCount < 2) {
          valid = false;
          this.toastr.error("Atleast 2 applicants are required for Joint account.");
        }
      }
    }
    return valid;
  }
  onSelectAccountType1(data) {
    const trueValueLkp = this.Lookups.AccountTypes.filter(x => x.LookupName == 'PKR');
    if (data) {
      this.IsAccount1Selected = true;
      this.IsAccountSelected = true;


      if (trueValueLkp.find(x => x.LookupId == data)) {
        this.IsPakRupeeAccount = true;
      }
      else if (trueValueLkp.find(p => p.LookupId == this.accountAppModel.AccountTypeLkp2) || trueValueLkp.find(p => p.LookupId == this.accountAppModel.AccountTypeLkp3) ||
        trueValueLkp.find(p => p.LookupId == this.accountAppModel.AccountTypeLkp4) || trueValueLkp.find(p => p.LookupId == this.accountAppModel.AccountTypeLkp5)) {
        this.IsPakRupeeAccount = true;
      }
      else
        this.IsPakRupeeAccount = false;
    }
    else if (this.IsAccount2Selected || this.IsAccount3Selected || this.IsAccount4Selected || this.IsAccount5Selected) {
      this.IsAccount1Selected = false;
      this.IsAccountSelected = true;
      if (trueValueLkp.find(p => p.LookupId == this.accountAppModel.AccountTypeLkp2)
        || trueValueLkp.find(p => p.LookupId == this.accountAppModel.AccountTypeLkp3) ||
        trueValueLkp.find(p => p.LookupId == this.accountAppModel.AccountTypeLkp4)
        || trueValueLkp.find(p => p.LookupId == this.accountAppModel.AccountTypeLkp5)) {
        this.IsPakRupeeAccount = true;
      }
      else
        this.IsPakRupeeAccount = false;
    }
    else {
      this.IsAccount1Selected = false;
      this.IsAccountSelected = false;
      this.IsPakRupeeAccount = false;
    }
  }
  onSelectAccountType2(data) {
    const trueValueLkp = this.Lookups.AccountTypes.filter(x => x.LookupName == 'PKR');
    if (data) {

      this.IsAccount2Selected = true;
      this.IsAccountSelected = true;
      if (trueValueLkp.find(p => p.LookupId == data)) {
        this.IsPakRupeeAccount = true;
      }
      else if (trueValueLkp.find(p => p.LookupId == this.accountAppModel.AccountTypeLkp1) || trueValueLkp.find(p => p.LookupId == this.accountAppModel.AccountTypeLkp3) ||
        trueValueLkp.find(p => p.LookupId == this.accountAppModel.AccountTypeLkp4) || trueValueLkp.find(p => p.LookupId == this.accountAppModel.AccountTypeLkp5)) {
        this.IsPakRupeeAccount = true;
      }
      else
        this.IsPakRupeeAccount = false;
    }
    else if (this.IsAccount1Selected || this.IsAccount3Selected || this.IsAccount4Selected || this.IsAccount5Selected) {
      this.IsAccount2Selected = false;
      this.IsAccountSelected = true;
      if (trueValueLkp.find(p => p.LookupId == this.accountAppModel.AccountTypeLkp1)
        || trueValueLkp.find(p => p.LookupId == this.accountAppModel.AccountTypeLkp3) ||
        trueValueLkp.find(p => p.LookupId == this.accountAppModel.AccountTypeLkp4)
        || trueValueLkp.find(p => p.LookupId == this.accountAppModel.AccountTypeLkp5)) {
        this.IsPakRupeeAccount = true;
      }
      else
        this.IsPakRupeeAccount = false;
    }
    else {
      this.IsAccount2Selected = false;
      this.IsAccountSelected = false;
      this.IsPakRupeeAccount = false;
    }
  }
  onSelectAccountType3(data) {
    const trueValueLkp = this.Lookups.AccountTypes.filter(x => x.LookupName == 'PKR');
    if (data) {
      this.IsAccount3Selected = true;
      this.IsAccountSelected = true;
      if (trueValueLkp.find(p => p.LookupId == data)) {
        this.IsPakRupeeAccount = true;
      }
      else if (trueValueLkp.find(p => p.LookupId == this.accountAppModel.AccountTypeLkp2) || trueValueLkp.find(p => p.LookupId == this.accountAppModel.AccountTypeLkp1) ||
        trueValueLkp.find(p => p.LookupId == this.accountAppModel.AccountTypeLkp4) || trueValueLkp.find(p => p.LookupId == this.accountAppModel.AccountTypeLkp5)) {
        this.IsPakRupeeAccount = true;
      }
      else
        this.IsPakRupeeAccount = false;
    }
    else if (this.IsAccount2Selected || this.IsAccount1Selected || this.IsAccount4Selected || this.IsAccount5Selected) {
      this.IsAccount3Selected = false;
      this.IsAccountSelected = true;
      if (trueValueLkp.find(p => p.LookupId == this.accountAppModel.AccountTypeLkp2)
        || trueValueLkp.find(p => p.LookupId == this.accountAppModel.AccountTypeLkp1) ||
        trueValueLkp.find(p => p.LookupId == this.accountAppModel.AccountTypeLkp4) ||
        trueValueLkp.find(p => p.LookupId == this.accountAppModel.AccountTypeLkp5)) {
        this.IsPakRupeeAccount = true;
      }
      else
        this.IsPakRupeeAccount = false;
    }
    else {
      this.IsAccount3Selected = false;
      this.IsAccountSelected = false;
      this.IsPakRupeeAccount = false;
    }
  }
  onSelectAccountType4(data) {
    const trueValueLkp = this.Lookups.AccountTypes.filter(x => x.LookupName == 'PKR');
    if (data) {
      this.IsAccount4Selected = true;
      this.IsAccountSelected = true;
      if (trueValueLkp.find(p => p.LookupId == data)) {
        this.IsPakRupeeAccount = true;
      }
      else if (trueValueLkp.find(p => p.LookupId == this.accountAppModel.AccountTypeLkp2) || trueValueLkp.find(p => p.LookupId == this.accountAppModel.AccountTypeLkp1) ||
        trueValueLkp.find(p => p.LookupId == this.accountAppModel.AccountTypeLkp3) || trueValueLkp.find(p => p.LookupId == this.accountAppModel.AccountTypeLkp5)) {
        this.IsPakRupeeAccount = true;
      }
      else
        this.IsPakRupeeAccount = false;
    }
    else if (this.IsAccount2Selected || this.IsAccount3Selected || this.IsAccount1Selected || this.IsAccount5Selected) {
      this.IsAccount4Selected = false;
      this.IsAccountSelected = true;
      if (trueValueLkp.find(p => p.LookupId == this.accountAppModel.AccountTypeLkp2) || trueValueLkp.find(p => p.LookupId == this.accountAppModel.AccountTypeLkp1) ||
        trueValueLkp.find(p => p.LookupId == this.accountAppModel.AccountTypeLkp3) || trueValueLkp.find(p => p.LookupId == this.accountAppModel.AccountTypeLkp5)) {
        this.IsPakRupeeAccount = true;
      }
      else
        this.IsPakRupeeAccount = false;
    }
    else {
      this.IsAccount4Selected = false;
      this.IsAccountSelected = false;
      this.IsPakRupeeAccount = false;
    }
  }
  onSelectAccountType5(data) {
    const trueValueLkp = this.Lookups.AccountTypes.filter(x => x.LookupName == 'PKR');
    if (data) {
      this.IsAccount5Selected = true;
      this.IsAccountSelected = true;
      if (trueValueLkp.find(p => p.LookupId == data)) {
        this.IsPakRupeeAccount = true;
      }
      else if (trueValueLkp.find(p => p.LookupId == this.accountAppModel.AccountTypeLkp2)
        || trueValueLkp.find(p => p.LookupId == this.accountAppModel.AccountTypeLkp1) ||
        trueValueLkp.find(p => p.LookupId == this.accountAppModel.AccountTypeLkp3) ||
        trueValueLkp.find(p => p.LookupId == this.accountAppModel.AccountTypeLkp4)) {
        this.IsPakRupeeAccount = true;
      }
      else
        this.IsPakRupeeAccount = false;
    }
    else if (this.IsAccount2Selected || this.IsAccount3Selected || this.IsAccount4Selected || this.IsAccount1Selected) {
      this.IsAccount5Selected = false;
      this.IsAccountSelected = true;
      if (trueValueLkp.find(p => p.LookupId == this.accountAppModel.AccountTypeLkp2)
        || trueValueLkp.find(p => p.LookupId == this.accountAppModel.AccountTypeLkp1) ||
        trueValueLkp.find(p => p.LookupId == this.accountAppModel.AccountTypeLkp3) ||
        trueValueLkp.find(p => p.LookupId == this.accountAppModel.AccountTypeLkp4)) {
        this.IsPakRupeeAccount = true;
      }
      else
        this.IsPakRupeeAccount = false;
    }
    else {
      this.IsAccount5Selected = false;
      this.IsAccountSelected = false;
      this.IsPakRupeeAccount = false;
    }
  }

  onSelectPakRupeeSav(data) {
    if (data) {
      this.IsPakRupeeAccountSav = data.checked;
    }
  }

  onSelectUSDSav(data) {
    if (data) {
      this.IsUSDAccountSav = data.checked;

    }
  }

  onEStatementSelectionChange(event) {

    // if (event.checked) {
    //   this.isEstatementFrequencyMandatory = true;
    //   if (!this.accountAppModel.EStatementFrequency) {
    //     this.accountAppModel.EStatementFrequency = this.statementMonthlyLkp;
    //   }
    // }
    // else {
    //   this.accountAppModel.EStatementFrequency = null;
    //   this.isEstatementFrequencyMandatory = false;
    // }

  }
  onCustomerRelationshipChange(data) {
    let allowedTypesforMultipleAppicants = ["joint"];
    if (this.accountAppModel.ContactNumber) {
      this.applicantDetails[0].ContactNumber = this.accountAppModel.ContactNumber;
    }

    // Keep this check in the end because there is a return condition when show multiple accounts is set true.
    if (data) {
      let selectedLkp = this.Lookups.CustomerRelationshipLkp.find(x => x.LookupId == data);
      if(data == this.accountAppModel['JointId'])
      {
        this.removeAllGuarantors();
      }
      if (selectedLkp) {
        if (allowedTypesforMultipleAppicants.includes(selectedLkp.HiddenValue.toLowerCase())) {
          this.showMultipleApplicants = true;
          return;
        }


      }
    }
    this.showMultipleApplicants = false;
  }
  onAccountOperationChange(data) {

    let disableDebitCardOnType = ["joint"];

    // Keep this check in the end because there is a return condition when show multiple accounts is set true.
    if (data) {
      let selectedLkp = this.Lookups.AccountOperationLkp.find(x => x.LookupId == data);
      if (selectedLkp) {
        if (disableDebitCardOnType.includes(selectedLkp.HiddenValue.toLowerCase())) {
          this.disableDebitCard = true;
          let noLkp = this.Lookups.Y_N.filter(x => x.HiddenValue == 'N');
          if (noLkp) {
            this.accountAppModel.DebitCard = noLkp.LookupId;
          }
          return;
        }
      }
    }
    this.disableDebitCard = false;
  }
  onCellNumberEdit(data) {
    this.applicantDetails[0].ContactNumber = this.accountAppModel.ContactNumber;
  }

  showOtherPurpose() {
    if (this.Lookups.PurposeOfRelationshipLkp) {
      let otherLkpId = this.Lookups.PurposeOfRelationshipLkp.filter((element) => { return element.HiddenValue == 'Others' })[0].LookupId;
      if (otherLkpId) {
        return (this.accountAppModel['PurposeOfAccountUDF'] == otherLkpId) ||
          (this.accountAppModel['PurposeOfAccountOneUDF'] == otherLkpId) ||
          (this.accountAppModel['PurposeOfAccountTwoUDF'] == otherLkpId)
      }
    }
    return false;
  }

  showHideOtherIncomeBox(selectedSource){
    if(this.Lookups.IncomeSource){
      let otherLkpId = this.Lookups.IncomeSource.filter((element) => { return element.HiddenValue.toLowerCase() == 'others' })[0].LookupId;
      return selectedSource == otherLkpId;
    }
    return false;
  }

  @HostListener('window:beforeunload', ['$event'])
  onWindowClose(event: any): void {
    // Do something
    if (!this.appConfig.testingMode && !this.allowExit) {
      event.returnValue = false;
      event.preventDefault();
    }
  }
  logApplication() {
    console.log(this.applicantDetails);
  }
}

